export default "__VITE_ASSET__B4BxLbq5__"